import React, { useRef, useCallback } from 'react';
import toastr from 'toastr';
import styles from './AddComment.module.css';
import { DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB, FILE_UPLOAD_FORMAT_OPTIONS } from '../../../../HelperMethods/constants';

const acceptAttributes = `${FILE_UPLOAD_FORMAT_OPTIONS.image.acceptedExtension},${FILE_UPLOAD_FORMAT_OPTIONS.pdf.acceptedExtension}`;
export default function AddAttachment({ onFilesSelected }) {
  const fileInputRef = useRef();
  const onAddAttachmentButtonClicked = useCallback(() => {
    fileInputRef.current.click();
  }, [fileInputRef]);
  const onFileChange = useCallback((e) => {
    if (e.target.files) {
      const maxFileSizeExceeded = Array.from(e.target.files).some(
        (file) => file.size / (1024 * 1024) > DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB
      );
      if (maxFileSizeExceeded) {
        toastr.error('File size exceeds 5MB limit');
      } else {
        onFilesSelected(e.target.files);
      }
      e.target.value = null;
    }
  });
  return (
    <>
      <button className={styles.buttons} type="button" onClick={onAddAttachmentButtonClicked}>
        <i style={{ transform: 'rotate(45deg)' }} className="fa fa-paperclip" />
        &nbsp;&nbsp;Add attachment
      </button>
      <input
        multiple
        style={{ display: 'none' }}
        ref={fileInputRef}
        accept={acceptAttributes}
        type="file"
        onChange={onFileChange}
      />
    </>
  );
}
